import './Alert.scss';

import { ReactComponent as Warning } from 'svg/WarningTriangle.svg';
import { ReactComponent as Info } from 'svg/InfoCircle.svg';
import { ReactComponent as Success } from 'svg/CheckmarkCircle.svg';
import { ReactComponent as Error } from 'svg/ErrorOctagon.svg';

export type AlertVariant = 'info' | 'success' | 'warning' | 'error';

type Props = {
  variant: AlertVariant;
  message: React.ReactNode;
};

const Alert = ({ variant, message }: Props) => {
  const getIcon = (v: AlertVariant) => {
    switch (v) {
      case 'info':
        return <Info className='Alert-icon' />;
      case 'success':
        return <Success className='Alert-icon' />;
      case 'warning':
        return <Warning className='Alert-icon' />;
      case 'error':
        return <Error className='Alert-icon' />;
    }
  };

  return (
    <div className={`Alert Alert--${variant}`}>
      {getIcon(variant)}
      <div className='Alert-message'>{message}</div>
    </div>
  );
};

export default Alert;
